var isNumber = require('./isNumber')

function isNumberFinite (obj) {
  return isNumber(obj) && isFinite(obj)
}

module.exports = isNumberFinite



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isFinite.js
// module id = QB3a
// module chunks = 137